import { lazy } from 'react';

// 使用懒加载导入所有页面组件
const Index = lazy(() => import('../pages/index/index'));
const Products = lazy(() => import('../pages/Products'));
const Clients = lazy(() => import('../pages/Clients'));
const AboutUs = lazy(() => import('../pages/AboutUs'));
const Services = lazy(() => import('../pages/Services'));



// 路由配置
const routes = [
  {
    path: '/',
    key: 'index',
    element: <Index />,
    exact: true,
  },//home
  {
    path: '/products',
    key: 'products',
    element: <Products />,
  },//products
  {
    path: '/clients',
    key: 'clients',
    element: <Clients/>,
  },//Clients & Business Scenarios
  {
    path: '/about',
    key: 'about',
    element: <AboutUs/>,
  },//About Us
  {
    path: '/services',
    key: 'services',
    element: <Services />,
  },//Services & Cooperation
];

export default routes;